module.exports = __webpack_public_path__ + "media/images/country_flags/vc-b0cfa4f379e3bdb6b6a62154a91942db.png";